import { Exclude, Expose, Type, Transform } from "class-transformer";

export class CustomerPlanVisitModel {
  constructor() {
    this.id = 0;
    this.prefix = "";
    this.name = "";
    this.code = "";
    this.owner = "";
    this.phone = "";
    this.latitude = 0;
    this.longitude = 0;
    this.image = "";
    this.note = "";
    this.address = "";
    this.agentType = "";
    this.salesOrg = "";

    this.eActivityList = [];
    this.customerPlanId = 0;
    this.saleOrgCriteriaId = undefined;
    this.planDate = undefined;
    this.suggestedBy = undefined;
    this.planID = undefined;
    this.routePlanId = undefined;
    this.isShowModalDistance = false;

    this.isDisableCheckIn = true;
    this.isDisableCheckout = true;
    this.checkInStatus = "";
    this.isEnableClosedReport = false;
    this.isEnableNoContactRequest = false;
    this.customerBillAddress = "";
    this.customerShipToAddress = "";
    this.salesOrgs = [];
    this.isExclusiveShop = false;
    this.locationType = "";
    this.customerCredit = undefined;
  }

  @Expose({ name: "customerId" })
  id: number;

  @Expose({ name: "customerPrefix" })
  prefix: string;

  @Expose({ name: "customerName" })
  name: string;

  @Expose({ name: "customerCode" })
  code: string;

  @Expose({ name: "ownerName" })
  owner: string;

  @Expose({ name: "customerTel" })
  phone: string;

  @Expose({ name: "customerAddress" })
  @Transform(({ value, obj }) => value || obj.address, { toClassOnly: true })
  address: string;

  @Expose({ name: "latitude" })
  @Transform(
    ({ value, obj }) =>
      (value !== undefined && value !== null
        ? value
        : obj.customerLocationData?.latitude) ?? null,
    { toClassOnly: true },
  )
  latitude: number | null;

  @Expose({ name: "longitude" })
  @Transform(
    ({ value, obj }) =>
      (value !== undefined && value !== null
        ? value
        : obj.customerLocationData?.longtitude) ?? null,
    { toClassOnly: true },
  )
  longitude: number | null;

  @Expose({ name: "customerPicName" })
  image: string;

  @Expose({ name: "note" })
  note: string | null;

  @Expose({ name: "agentType" })
  agentType: string;

  @Expose({ name: "salesOrg" })
  salesOrg: string;

  @Expose({ name: "isShowModalDistance" })
  isShowModalDistance: boolean;

  @Expose({ name: "eActivityList" })
  eActivityList: [];

  @Expose({ name: "customerPlanId" })
  customerPlanId: number | string | null;

  @Expose({ name: "saleOrgCriteriaId" })
  saleOrgCriteriaId?: number | string | null;

  @Expose({ name: "planDate" })
  planDate?: string | null;

  @Expose({ name: "suggestedBy" })
  suggestedBy?: string | null;

  @Expose({ name: "planID" })
  planID?: number | string | null;

  @Expose({ name: "routePlanId" })
  routePlanId?: number | string | null;

  @Expose({ name: "isEnableClosedReport" })
  isEnableClosedReport: boolean;

  @Expose({ name: "isEnableNoContactRequest" })
  isEnableNoContactRequest: boolean;

  @Expose({ name: "isDisableCheckIn" })
  isDisableCheckIn: boolean;
  isDisableCheckout: boolean;
  checkInStatus: string; // IN ==> already check in (need to display checkout)

  @Expose({ name: "customerBillAddress" })
  customerBillAddress: string;

  @Expose({ name: "customerShipAddress" })
  customerShipToAddress: string;

  @Type(() => SalesOrgItemModel)
  @Expose({ name: "salesOrgs" })
  salesOrgs: SalesOrgItemModel[];

  @Expose({ name: "isExclusiveShop" })
  isExclusiveShop: boolean;

  @Expose({ name: "locationType" })
  locationType: string;

  @Type(() => CustomerCreditModel)
  @Expose({ name: "customerCredit" })
  customerCredit?: CustomerCreditModel;
}
export class OutRangeVisitItemModel {
  constructor() {
    this.reasonType = "OTHER";
    this.reason = "";
  }

  @Expose({ name: "reasonType" })
  reasonType: "TEXT" | "OTHER";
  @Expose({ name: "reason" })
  reason: string;
}

export class OutRangeVisitReasonModel {
  constructor() {
    this.data = [] as OutRangeVisitItemModel[];
  }
  @Expose({ name: "data" })
  data: OutRangeVisitItemModel[];
}

export class ClosedReasonItemModel {
  constructor() {
    this.reasonType = "OTHER";
    this.reason = "";
  }

  @Expose({ name: "reasonType" })
  reasonType: "TEXT" | "OTHER";
  @Expose({ name: "reason" })
  reason: string;
}

export class ClosedReasonModel {
  constructor() {
    this.data = [] as ClosedReasonItemModel[];
  }
  @Expose({ name: "data" })
  data: ClosedReasonItemModel[];
}

export class CalculateOutRange {
  constructor() {
    this.isShowModalDistance = false;
  }
  isShowModalDistance: Boolean;
}

export class CheckActivityBeforeCheckout {
  constructor() {
    this.hasActivity = false;
  }
  hasActivity: Boolean;
}

export class EmployeePreVisitModel {
  constructor() {
    this.customerId = 0;
    this.targetAmt = 0;
    this.targetBaseAmt = 0;
    this.targetNetAmt = 0;
    this.estimateAmt1 = 0;
    this.estimateAmt2 = 0;
    this.estimateAmt3 = 0;
    this.estimateAmt4 = 0;
    this.estimateNetAmt = 0;
    this.estimateTsgamt = 0;
    this.estimateBaseAmt = 0;
    this.cusTargetAmt = 0;
    this.cusExportAmt = 0;
    this.cusProfitTradeAmt = 0;
    this.cusBeerAmt = 0;
    this.cusProfSaleNetAmt = 0;
    this.cusProfFreeNetAmt = 0;
    this.cusGBAwdNetAmt = 0;
    this.cusDedicateNetAmt = 0;
    this.cusOther = "";
    this.cusReason = "";
    this.stockRemainEarlyAmt = 0;
    this.stockEarlyAmt = 0;
    this.stockBuyNetAmt = 0;
    this.stockCarryAmt = 0;
    this.stockExportAmt = 0;
    this.stockRemainEndAmt = 0;
    this.stockEndNetAmt = 0;
    this.stockPercentAmt = 0;
    this.employeePreVisitId = 0;
  }

  @Expose({ name: "customerId" })
  customerId: number;

  @Expose({ name: "targetAmt" })
  targetAmt: number;

  @Expose({ name: "targetBaseAmt" })
  targetBaseAmt: number;

  @Expose({ name: "targetNetAmt" })
  targetNetAmt: number;

  @Expose({ name: "estimateAmt1" })
  estimateAmt1: number;

  @Expose({ name: "estimateAmt2" })
  estimateAmt2: number;

  @Expose({ name: "estimateAmt3" })
  estimateAmt3: number;

  @Expose({ name: "estimateAmt4" })
  estimateAmt4: number;

  @Expose({ name: "estimateNetAmt" })
  estimateNetAmt: number;

  @Expose({ name: "targetAmt" })
  estimateTsgamt: number;

  @Expose({ name: "estimateBaseAmt" })
  estimateBaseAmt: number;

  @Expose({ name: "cusTargetAmt" })
  cusTargetAmt: number;
  @Expose({ name: "cusExportAmt" })
  cusExportAmt: number;

  @Expose({ name: "cusProfitTradeAmt" })
  cusProfitTradeAmt: number;
  @Expose({ name: "cusBeerAmt" })
  cusBeerAmt: number;
  @Expose({ name: "cusProfSaleNetAmt" })
  cusProfSaleNetAmt: number;
  @Expose({ name: "cusProfFreeNetAmt" })
  cusProfFreeNetAmt: number;
  @Expose({ name: "cusGBAwdNetAmt" })
  cusGBAwdNetAmt: number;
  @Expose({ name: "cusDedicateNetAmt" })
  cusDedicateNetAmt: number;
  @Expose({ name: "cusOther" })
  cusOther: string;
  @Expose({ name: "cusReason" })
  cusReason: string;

  @Expose({ name: "stockRemainEarlyAmt" })
  stockRemainEarlyAmt: number;
  @Expose({ name: "stockEarlyAmt" })
  stockEarlyAmt: number;
  @Expose({ name: "stockBuyNetAmt" })
  stockBuyNetAmt: number;
  @Expose({ name: "stockCarryAmt" })
  stockCarryAmt: number;
  @Expose({ name: "stockExportAmt" })
  stockExportAmt: number;
  @Expose({ name: "stockRemainEndAmt" })
  stockRemainEndAmt: number;
  @Expose({ name: "stockEndNetAmt" })
  stockEndNetAmt: number;
  @Expose({ name: "stockPercentAmt" })
  stockPercentAmt: number;
  @Expose({ name: "employeePreVisitId" })
  employeePreVisitId: number;
}

export class SuccessPreVisitModel {
  constructor() {
    this.isSuccess = false;
    this.employeePreVisitId = 0;
  }

  isSuccess: boolean;
  employeePreVisitId: number;
}

export class SurveyItemModel {
  constructor() {
    this.id = 0;
    this.name = "";
    this.url = "";
    this.flag = "";
    this.date = "";
    this.isActivity = false;
  }

  @Expose({ name: "surveyId" })
  id: number;
  @Expose({ name: "surveyName" })
  name: string;
  @Expose({ name: "surveyUrl" })
  url: string;
  @Expose({ name: "surveyFlag" })
  flag: string;
  @Expose({ name: "surveyDate" })
  date: string;
  @Expose({ name: "isEActivitySurvey" })
  isActivity: boolean;
}

export class SurveyListModel {
  constructor() {
    this.type = "";
    this.list = [];
  }

  @Expose({ name: "type" })
  type: string;
  @Expose({ name: "lstSurvey" })
  list: SurveyItemModel[];
}

export class SuccessSurveyModel {
  constructor() {
    this.isEActivity = false;
    this.isSuccess = false;
    this.url = "";
    this.name = "";
    this.message = "";
    this.date = "";
  }

  @Expose({ name: "isSuccess" })
  isSuccess: boolean;

  @Expose({ name: "surveyUrl" })
  url: string;

  @Expose({ name: "surveyName" })
  name: string;

  @Expose({ name: "message" })
  message: string;

  @Expose({ name: "surveyDate" })
  date: string;

  @Expose({ name: "isEActivitySurvey" })
  isEActivity: boolean;
}

export class MenuCallPlanItem {
  constructor() {
    this.menuId = undefined;
    this.menuName = "";
    this.menuGroup = "";
    this.menuHandler = "";
    this.menuIconURL = "";
    this.canAccess = false;
    this.canUpdate = false;
    this.canDelete = false;
  }

  menuId: number | undefined;
  menuName: string;
  menuGroup: string;
  menuHandler: string;
  menuIconURL: string;
  canAccess: boolean;
  canUpdate: boolean;
  canDelete: boolean;
}

export class SalesOrgItemModel {
  constructor() {
    this.salesOrg = "";
    this.salesOrgCriteria = "";
  }
  @Expose({ name: "salesOrg" })
  salesOrg: string;

  @Expose({ name: "salesOrgCriteria" })
  salesOrgCriteria: string;
}

export class CustomerCreditModel {
  constructor() {
    this.creditLimit = "0";
    this.remainingCredit = "0";
  }
  @Expose({ name: "creditLimit" })
  creditLimit: string;

  @Expose({ name: "remainingCredit" })
  remainingCredit: string;
}
